import React from "react";
import PhImage from "../common/PhImage";

export default function ProjectCard({ project, onOpen }) {
  const stop = (e) => e.stopPropagation();

  return (
    <article className="project-card" onClick={() => onOpen(project.id)}>
      <PhImage
        className="project-media"
        src={project.image}
        alt={project.title}
      />
      <div className="project-body">
        <div className="project-top-row mono">
          <span className="project-index">{project.index}</span>
          <span className="project-platform-label">
            {project.platformsLabel}
          </span>
        </div>
        <h3 className="project-title">{project.title}</h3>
        <p className="project-desc">{project.cardDescription}</p>
        <div className="tag-row mono">
          {project.cardTags.map((tag) => (
            <span className="tag-pill" key={tag}>
              {tag}
            </span>
          ))}
        </div>
        <div className="project-links mono">
          {project.live && project.live !== "none" && (
            <a
              className="lnk project-link-live"
              href={project.live}
              target="_blank"
              rel="noreferrer"
              onClick={stop}
            >
              Live ↗
            </a>
          )}
          <a
            className="lnk project-link-code"
            href={project.repo}
            target="_blank"
            rel="noreferrer"
            onClick={stop}
          >
            Code {project.live === "none" ? "↗" : ""}
          </a>
        </div>
      </div>
    </article>
  );
}
